import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-password',
    imports: [FormsModule, ReactiveFormsModule],
    templateUrl: './password.component.html',
    styleUrl: './password.component.scss'
})
export class PasswordComponent {
 @Input() field: any = {};
  @Input() form!: FormGroup;
  get isValid() { return this.form.controls[this.field.name].valid; }
  get isDirty() { return this.form.controls[this.field.name].dirty; }
  showPassword: boolean =false;
  constructor() { }

  ngOnInit(): void {
    console.log(this.field, '<---------input text----------->')
  }
   // Method for password eye icon show and hide the password text
  togglePassword() {
    this.showPassword = !this.showPassword;
  }
}
